<template>
  <v-slide-y-transition>
    <div v-if="dDayDate" class="text-center mb-5">
      <h2 class="text-h5 font-weight-bold text-primary mb-2">
        만날 날까지 D-{{ daysRemaining }}
      </h2>
      <div style="position: relative;" class="my-4">
        <v-progress-linear
          :model-value="progressPercentage"
          height="8"
          class="emotional-progress"
          bg-color="grey-lighten-1"
          style="border-radius: 4px; border: 1px solid #CCCCCC; box-sizing: border-box;"
        ></v-progress-linear>
        
        <!-- 1/3 지점 마커 (은은한 원) -->
        <div style="position: absolute; left: 33.33%; top: 0; height: 8px; width: 8px; background-color: #FFFFFF; border-radius: 50%; transform: translateX(-50%); z-index: 2; opacity: 0.8;"></div>
        <!-- 2/3 지점 마커 (은은한 원) -->
        <div style="position: absolute; left: 66.66%; top: 0; height: 8px; width: 8px; background-color: #FFFFFF; border-radius: 50%; transform: translateX(-50%); z-index: 2; opacity: 0.8;"></div>
      </div>
      <div class="text-caption text-grey mt-1">기다림의 시간 중 {{ progressPercentage }}%가 지났습니다.</div>
    </div>
  </v-slide-y-transition>
</template>

<script>
export default {
  name: 'DDayProgress',
  props: {
    dDayDate: {
      type: [String, Date],
      default: null
    },
    daysRemaining: {
      type: [Number, String],
      default: 0
    },
    progressPercentage: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style scoped>
.emotional-progress :deep(.v-progress-linear__determinate) {
  background-color: transparent !important;
  background-image: linear-gradient(90deg, #ff9a9e 0%, #ff9a9e 40%, #ffe4e1 50%, #ff9a9e 60%, #ff9a9e 100%) !important;
  background-size: 200% 100% !important;
  animation: gradientFlow 5s linear infinite !important;
  border-radius: 4px;
}

@keyframes gradientFlow {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: -100% 0;
  }
}
</style>
